// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1j_yi","actionsCol":"EnrolledClinics_actionsCol__q80pt"};